"use client";

// Persistent floating chat entry on every page (Play 3 of the AI Astrologer
// prominence audit). Hidden on /free-kundali/, /ai-astrologer/, /free-astrology-chat/
// where InlineChatPreview / KundaliResult.ChatPanel already render the chat
// inline — a sticky pill on top of those would be redundant noise.

import Link from "next/link";
import { usePathname } from "next/navigation";

import { shouldShowStickyChatButton } from "@/lib/global-overlays";
import { safeSessionSet } from "@/lib/browser-storage";

export default function StickyChatButton() {
  const pathname = usePathname();
  if (!shouldShowStickyChatButton(pathname)) return null;
  const isHindi = pathname === "/hi" || pathname?.startsWith("/hi/");
  // Hindi must land on a chat-first surface, mirroring the English destination.
  // /hi/astrologers/ is a persona DIRECTORY whose cards are inert while
  // APP_AVAILABLE=false — routing the global chat CTA there was a dead end
  // (hi first_msg 6.7% vs en 29.8%, 30d to 2026-08-13).
  const chatHref = isHindi ? "/hi/muft-jyotish-chat/" : "/ai-astrologer/";

  function handleClick() {
    try {
      safeSessionSet("seo_entry_path", pathname || "/");
    } catch {
      // Best-effort context handoff.
    }
    void import("@/lib/analytics-events").then(({ trackEvent }) => {
      trackEvent("sticky_chat_button_clicked", {
        source_path: pathname || "/",
      });
    });
  }

  return (
    <Link
      href={chatHref}
      prefetch={false}
      onClick={handleClick}
      aria-label={isHindi ? "AI Jyotishi se poochhein" : "Ask the AI Jyotishi"}
      className="fixed bottom-[76px] right-4 z-40 flex items-center gap-2 rounded-full px-4 py-3 text-[13px] font-semibold shadow-lg transition hover:scale-105 sm:bottom-6"
      style={{
        background: "var(--ish-accent)",
        color: "#fff",
        boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
      }}
    >
      <span aria-hidden className="text-[16px]">
        ॐ
      </span>
      <span className="hidden sm:inline">
        {isHindi ? "Pandit-ji se poochhein" : "Ask Pandit-ji"}
      </span>
      <span className="sm:hidden">{isHindi ? "Jyotishi se poochhein" : "Ask Jyotishi"}</span>
    </Link>
  );
}
